import { emitter } from 'shared/helpers/mitt';

/**
 * Handles pipeline API errors, showing a user-friendly toast for 403 Forbidden responses.
 * Use this in catch blocks of pipeline store actions and component API calls.
 *
 * @param {Error} error - The axios error object
 * @param {Function} [t] - Optional vue-i18n translation function. Falls back to a static message.
 * @returns {Error} - Re-throws the error after handling
 */
export function handlePipelineError(error, t = null) {
  if (error?.response?.status === 403) {
    const message = t
      ? t('PIPELINE.ERRORS.FORBIDDEN')
      : 'Você não tem permissão para executar esta ação.';

    emitter.emit('newToastMessage', {
      message,
      action: { type: 'error' },
    });
  }
  throw error;
}
